import { toReferenceListItems } from "../utils/mappers/to-reference-list-item";
import { toVehicleModelOptions } from "../utils/mappers/to-vehicle-model-options";
import {
	REFERENCE_LIST,
	type ReferenceList,
	type ReferenceListItem,
	type VehicleModelOption,
} from "../types/reference-list.types";
import {
	getBodyStyles,
	getColors,
	getEquipment,
	getIntents,
	getVehicleModels,
} from "@/lib/api";

const FETCHERS = {
	[REFERENCE_LIST.EQUIPMENT]: getEquipment,
	[REFERENCE_LIST.INTENTS]: getIntents,
	[REFERENCE_LIST.BODY_STYLES]: getBodyStyles,
	[REFERENCE_LIST.COLORS]: getColors,
} satisfies Record<ReferenceList, unknown>;

export const referenceListsService = {
	async getReferenceList(
		list: ReferenceList,
		signal?: AbortSignal
	): Promise<Array<ReferenceListItem>> {
		const response = await FETCHERS[list](signal);
		return toReferenceListItems(response.items);
	},

	async getVehicleModels(
		signal?: AbortSignal
	): Promise<Array<VehicleModelOption>> {
		const response = await getVehicleModels(signal);
		return toVehicleModelOptions(response.items);
	},
};
